<template>
  <div class="predefined while-waiting">
    <p><strong>Nothilfe angefordert</strong></p>
    <p>Allgemeine Hinweise:</p>
    <ol>
      <li>Einschalten der Warnblinkanlage</li>
      <li>Warnweste anlegen</li>
      <li>
        Sorgen Sie dafür, dass alle Insassen auf dem kürzesten Weg den
        Gefahrenbereich der Fahrbahn verlassen.
      </li>
      <li>
        Aufstellen des Pannendreiecks (in angemessenem Abstand hinter dem
        Fahrzeug, bei Kurven stets vor deren Beginn).
      </li>
      <li>
        Wenn Sie zusätzlich den Kofferraumdeckel öffnen, sehen nachfligende
        Fahrzeuge sofort, dass Ihr Auto steht. (Achtung: Innerorts mögliche
        Diebstahlgefahr)
      </li>
    </ol>
    <div class="buttons-wrapper">
      <oeamtc-link-button href="oeamtc://app/wordbook/" target="_blank">
        Wörterbuch
      </oeamtc-link-button>
      <oeamtc-link-button
        href="oeamtc://app/schutzbrief/service_description/001_nach_fahrzeugausfall"
        target="_blank"
      >
        So hilft der Schutzbrief
      </oeamtc-link-button>
    </div>
  </div>
</template>

<script>
import { OeamtcLinkButton } from '@oeamtc/styleguide-vuejs-lib-ui';

export default {
  name: 'WhileWaiting',
  components: { OeamtcLinkButton },
};
</script>

<style lang="scss" scoped>
ol {
  padding-left: 20px;
}
.buttons-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    margin: 5px 0;
    // padding-left: 0;
    // padding-right: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
